// Who signs staff documents, and which pages a member of staff who hasn't
// signed a required one is kept out of. The home page, their own account and
// the staff documents pages themselves stay open.
// STAFF is everyone else on the staff: Finance and the club's own roles.
export const SIGNER_ROLES = ['COACH', 'CLUB_ADMIN', 'WELFARE', 'STAFF'];

export const SIGNER_ROLE_LABELS = {
  COACH: 'Coaches',
  CLUB_ADMIN: 'Club admins',
  WELFARE: 'Welfare Officers',
  STAFF: 'Other staff (Finance and your own roles)',
};

const STAFF_PATHS = [
  '/admin-hub', '/gymnasts', '/levels', '/skills', '/routines-to-check',
  '/competitions', '/progress', '/diary-overview', '/certificates', '/certificate-designer',
  '/branding', '/booking/admin',
];

const documentsOf = user => (SIGNER_ROLES.includes(user?.role) ? user?.staffDocuments?.documents || [] : []);

// Required documents this person hasn't signed at the current version. The
// server only lists documents the person can see.
export const documentsToSign = user => documentsOf(user).filter(d => d.required && !d.signed);

// A Preview as account is read-only, so it can't sign: it sees the documents
// but is never kept out of the staff pages
export const mustSignStaffDocuments = user => !user?.isPreview && documentsToSign(user).length > 0;

// Whether the club requires any document of this person (others only see the
// Staff documents tile once there is one)
export const hasRequiredDocuments = user => documentsOf(user).some(d => d.required);

export const isStaffPath = pathname =>
  STAFF_PATHS.some(p => pathname === p || pathname.startsWith(`${p}/`));

export const dateLabel = iso => new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
export const errorMessage = (err, fallback) => err.response?.data?.error || fallback;

export const fileSizeLabel = bytes => {
  if (!Number.isFinite(bytes)) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

// Updates one document's entry in the status kept on the signed-in user
export const withDocumentStatus = (user, id, changes) => ({
  ...user,
  staffDocuments: {
    ...user?.staffDocuments,
    documents: (user?.staffDocuments?.documents || []).map(d => (d.id === id ? { ...d, ...changes } : d)),
  },
});
